import React, {Fragment} from 'react'
import {connect} from 'react-redux'
import {Card} from 'common/styleguide/Card'
import {URLTabCard, TabCardItem} from 'common/styleguide/TabCard'
import {ColWrap, MainCol, SecondaryCol} from 'common/layouts/SideNavLayout/TwoCol'
import {Loadable} from 'common/Loadable'
import {camelCaseKeys} from 'lib/utils'
import _ from 'lodash'
import fetchJSON from 'lib/fetchJSON'
import {ProfileCard} from './ProfileCard'
import {GearList} from './GearList'
import {Photos} from './Photos'
import {MatchedSegments} from './MatchedSegments'
import {CreatedSegments} from './CreatedSegments'
import {apiv3} from 'lib/apiv3'
import Helmet from 'react-helmet'
import * as userActions from 'lib/api/currentUser'
import {IeNudgeBar} from 'common/IeNudgeBar'

export class More extends React.PureComponent {
  render () {
    const {currentUser, loadableResources, setPreference} = this.props
    const {segmentMatches, gear, photos} = loadableResources
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode

    return (
      <Fragment>
        <IeNudgeBar currentUser={currentUser} setPreference={setPreference} />
        <ColWrap collapseReverse={!isIE11} isIE={isIE11}>
          <Helmet title='More · Ride with GPS' />
          <MainCol>
            <h2 data-heading-alt>Photos</h2>
            <Card>
              <Photos photos={photos} currentUser={currentUser} />
            </Card>

            <URLTabCard name='segmentsTab'>
              <TabCardItem id='matched' title='Matched Segments'>
                <MatchedSegments segmentMatches={segmentMatches} user={currentUser} />
              </TabCardItem>
              <TabCardItem id='created' title='Created'>
                <CreatedSegments currentUser={currentUser} />
              </TabCardItem>
            </URLTabCard>
          </MainCol>
          <SecondaryCol>
            <h2 data-heading-alt>About</h2>
            <Card noPadding>
              <ProfileCard user={currentUser} />
            </Card>

            <h2 data-heading-alt>Gear</h2>
            <Card>
              <GearList gear={gear} />
            </Card>
          </SecondaryCol>
        </ColWrap>
      </Fragment>
    )
  }
}

// this is old and janky because we don't have apiv3 coverage
// for /users/?/segment_matches yet
const loadInitialData = _.memoize((currentUser) => {
  // endpoint doesn't support order_by since it's doing manual .map
  // serialization... so let's do it on the frontend!
  const getSegmentMatches = fetchJSON(`/users/${currentUser.id}/segment_matches.json?apikey=x&version=2`)
    .then(({matches}) => matches.map(camelCaseKeys))
    .then(matches => _.orderBy(matches, 'name'))

  const getGear = apiv3.users.gears(currentUser.id)
    .then(({results}) => results.map(camelCaseKeys))

  const getPhotos = fetchJSON(`/users/${currentUser.id}/photos.json?limit=8`)
    .then(({photos}) => photos)

  return Promise.all([getSegmentMatches, getGear, getPhotos])
    .then(([segmentMatches, gear, photos]) => ({segmentMatches, gear, photos}))
})

const LoadableMore = (props) => {
  return <Loadable
    {...props}
    component={More}
    loadingText='Loading your segments and photos'
    resourceLoaded={() => loadInitialData(props.currentUser)} />
}

export const MoreContainer = connect(
  state => ({currentUser: state.currentUser}),
  {setPreference: userActions.setPreference}
)(LoadableMore)
